import * as z from "zod";

export const uploadSkuGroupingCsv = {
  name: "uploadSkuGroupingCsv" as const,
  input: z.object({}),
  output: z.object({
    success: z.boolean(),
    csvFileUrl: z.string(),
    rowCount: z.number(),
  }),
};
